export { ReactComponent as Trashcan } from './svgs/trashcan.svg';
